<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockConfirm.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockConfirm.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <a-tabs :default-active-key="1" tab-position="top" @change="callback">
          <a-tab-pane :key="1">
            <span slot="tab">
              <i class="fas fa-file-invoice ts-mr-3"></i>
              {{ $t('stockConfirm.stockIn') }}
            </span>
            <StockIn v-if="active_tab == 1" />
          </a-tab-pane>
          <a-tab-pane :key="2">
            <span slot="tab">
              <i class="fas fa-trash-alt ts-mr-3"></i>
              {{ $t('stockConfirm.writeOff') }}
            </span>
            <WriteOff v-if="active_tab == 2" />
          </a-tab-pane>
        </a-tabs>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import StockIn from './components/stock-in-list'
import WriteOff from './components/write-off-list'
export default {
  name: 'stockConfirm',
  components: {
    StockIn,
    WriteOff
  },
  data () {
    return {
      active_tab: 1
    }
  },
  methods: {
    callback (key) {
      this.active_tab = key
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/stockInConfirm/RESET_STATE')
    this.$store.commit('stock/writeOffConfirm/RESET_STATE')
    next()
  }
}
</script>
